import { render } from "./AsModal.vue?vue&type=template&id=56591ee2&ts=true"
import script from "./AsModal.vue?vue&type=script&lang=ts"
export * from "./AsModal.vue?vue&type=script&lang=ts"

import "./AsModal.vue?vue&type=style&index=0&id=56591ee2&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__